import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPhoneTopPunchHoleCenter: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="phone-top-punch-hole-center"><path fillRule="evenodd" clipRule="evenodd" d="M17 3C19.2091 3 21 4.79086 21 7V20.25C21 20.6642 20.6642 21 20.25 21H3.75C3.33579 21 3 20.6642 3 20.25V7C3 4.79086 4.79086 3 7 3H17ZM12 5C11.4477 5 11 5.44772 11 6C11 6.55228 11.4477 7 12 7C12.5523 7 13 6.55228 13 6C13 5.44772 12.5523 5 12 5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconPhoneTopPunchHoleCenter;
